import Vue from "vue"
import VueCookies from "vue-cookies"
Vue.use(VueCookies)

const getDomain = () => {
  const parts = location.hostname.split(".")
  return parts.slice(-2).join(".")
}
Vue.$cookies.config("", "", getDomain(), "", "")
